/**
 * Course Grid Component
 *
 * Grid layout component for displaying multiple courses in a responsive
 * 2x2 grid on desktop and single column on mobile.
 */

import React from 'react';
import { Course } from '../../types/course';
import CourseCard from './CourseCard';

interface CourseGridProps {
  courses: Course[];
  onCourseClick: (course: Course) => void;
  className?: string;
}

const CourseGrid: React.FC<CourseGridProps> = ({
  courses,
  onCourseClick,
  className = '',
}) => {
  if (courses.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No courses available at this time.</p>
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${className}`}>
      {courses.map((course, index) => (
        <div
          key={course.id}
          data-aos="fade-up"
          data-aos-delay={index * 100}
          data-aos-duration="600"
        >
          <CourseCard
            course={course}
            onClick={onCourseClick}
          />
        </div>
      ))}
    </div>
  );
};

export default CourseGrid;
